import DeviceDataTable from '@components/_shared/DeviceDataTable/DeviceDataTable';
import useGetInternalWidgetConfig from '@hooks/api/queries/widgets/useGetInternalWidgetConfig';
import { Box } from '@mui/material';
import { generateMqttClient } from '@pages/_loader/initMqttClient.loader';
import { WidgetTypeDeviceList } from '@src/types/Widget';
import { MqttClient } from 'mqtt';
import React, { useEffect } from 'react';

function PowinBessRackList({ selectedBessId }: { selectedBessId: string }) {
  const [mqttClient, setMqttClient] = React.useState<MqttClient>();

  // biome-ignore lint/correctness/useExhaustiveDependencies: to run once only
  useEffect(() => {
    const startClient = async () => {
      const client = await generateMqttClient();
      setMqttClient(client);
    };
    startClient();
    return () => {
      mqttClient?.end();
    };
  }, []);

  const { data: widgetConfig } =
    useGetInternalWidgetConfig<WidgetTypeDeviceList>(
      'powinRackList',
      {
        sourceDeviceId: selectedBessId,
      },
      { enabled: !!selectedBessId },
    );

  return (
    <Box
      sx={{
        mt: 3,
      }}
    >
      {widgetConfig ? (
        <DeviceDataTable
          widgetId='bess_rack'
          hideFooter
          additionalClassnames='detail-data-table'
          devices={widgetConfig?.devices || []}
          dataPoints={widgetConfig?.dataPoints || []}
          pointConfigRefs={widgetConfig?.pointConfigRefs || []}
          useDualListView={widgetConfig?.useDualListView ?? false}
          mqttClient={mqttClient}
        />
      ) : (
        <></>
      )}
    </Box>
  );
}

export default PowinBessRackList;
